"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  > section > div {\n    margin: 0 auto;\n  }\n  .footer-main-content {\n    padding-top: ", ";\n    background-color: ", ";\n    min-height: 320px;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n  .ft-bottom {\n    background-color: black;\n    min-height: 96px;\n    width: 100%;\n  }\n  .ft-bottom-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FooterContainer = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.colors.textColor;
}, function (props) {
  return props.colors.backgroundColor;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.spacingObj.padding * 4 + 'px';
}, function (props) {
  return props.colors.backgroundColor;
}, function (props) {
  return props.spacingObj.padding;
}, function (props) {
  return props.spacingObj.padding;
}, function (props) {
  return props.spacingObj.padding;
}, function (props) {
  return props.spacingObj.padding;
});
/**
 * Footers are designed to display content at the bottom of a page.
 * @example import { Footer } from @desktop/react;
 */


var Footer = function Footer(props) {
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()['footer'];
  return /*#__PURE__*/_react["default"].createElement(FooterContainer, {
    style: props.style,
    spacingObj: spacing,
    colors: context.getColors()['footer'],
    fontFamilyObj: context.getFont()
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "ft-main",
    style: props.mainContentStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "footer-main-content"
  }, props.mainContent)), props.bottomContent.length !== 0 && /*#__PURE__*/_react["default"].createElement("section", {
    className: "ft-bottom",
    style: props.bottomContentStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "footer-bottom-content"
  }, props.bottomContent)));
};

exports.Footer = Footer;
Footer.propTypes = {
  /**The content to be contained and positioned in the main container in the footer. */
  mainContent: _propTypes["default"].node,

  /**The content to be contained and positioned in the bottom container in the footer.*/
  bottomContent: _propTypes["default"].node,

  /**The overriding styling of the footer element. */
  style: _propTypes["default"].object,

  /**The overriding styling of the main footer container */
  mainContentStyle: _propTypes["default"].object,

  /**The overriding styling of the bottom footer container */
  bottomContentStyle: _propTypes["default"].object
};
Footer.defaultProps = {
  style: {},
  mainContent: null,
  bottomContent: null,
  mainContentStyle: {},
  bottomContentStyle: {}
};